import { useMutation } from '@tanstack/react-query';

import { TypeCodeState } from '../../types';
import { API_VERSION_V2 } from '~/constants';
import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeRegisterContractWorkInfoParams = {
  cluster: string;
  center: string;
  workPart: string;
  teamName: string;
  workStartTime: string;
  workEndTime: string;
  masterContractSeq?: number;
  masterContractVersionSeq?: number;
  availableContractStartTime?: string;
  availableContractEndTime?: string;
};

type TypeRegisterContractWorkInfoResponse = {
  code: string;
  message: string;
  data: {
    contractDate: string;
    contractStatus: TypeCodeState;
    name: string;
    juminNo: string;
    address: string;
    detailAddress: string;
    financialInstitution: TypeCodeState;
    accountNo: string;
    phoneNumber: string;
    certificated: boolean;
  };
};

export const useRegisterContractWorkInfo = () => {
  const endpoint = '/labor/contract';

  const REQUEST_REGISTER_CONTRACT_WORK_INFO = 30 * 1000;

  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeRegisterContractWorkInfoParams) => {
      return axiosInstance.post(endpoint, params, {
        timeout: REQUEST_REGISTER_CONTRACT_WORK_INFO,
        headers: { version: API_VERSION_V2 },
      });
    },
  });

  const requestRegisterContractWorkInfo = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeRegisterContractWorkInfoParams;
    onSuccess: (response: TypeRegisterContractWorkInfoResponse) => void;
    onError?: (error: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestRegisterContractWorkInfo;
};
